import React, { useState, useEffect } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Add,
  DeleteForever
} from "@mui/icons-material";

import { 
  StartEquipmentOption, 
  StartEquipmentItem, 
} from "@dndModels";

import StartEquipmentItemInput from "@dndComponents/equipment/StartEquipmentItemInput";

interface Props {
  option: StartEquipmentOption;
  onChange: (changed: StartEquipmentOption) => void; 
  onDelete: () => void;
  disabled: boolean;
}

export default function StartEquipmentOptionInput({ 
  option,
  onChange,
  onDelete,
  disabled
}: Props) {
  const [my_option, setOption] = useState(option.clone());
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row" style={{ paddingLeft: "4px" }}>
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header">
          Items
        </span>
        { !disabled &&
          <Tooltip title={`Add New Item`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                const new_option = my_option;
                const item = new StartEquipmentItem();
                new_option.items.push(item);
                setOption(new_option);
                onChange(new_option);
                setReloading(true);
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        }
        { !disabled &&
          <Tooltip title={`Remove Option`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      { !reloading && my_option.items.map((item, key) => {
        return (
          <Grid
            key={key}
            size={{
              xs: 12
            }}>
            <div style={{ paddingLeft: "4px", width: "calc(100% - 4px)" }}>
              <StartEquipmentItemInput
                item={item}
                disabled={disabled}
                onChange={(changed: StartEquipmentItem) => {
                  const new_option = my_option;
                  const option_finder = new_option.items.filter(o => o.id === changed.id);
                  if (option_finder.length === 1) {
                    const option = option_finder[0];
                    option.copy(changed);
                    setOption(new_option);
                    onChange(new_option);
                  }
                }}
                onDelete={() => {
                  const new_option = my_option;
                  new_option.items = new_option.items.filter(o => o.id !== item.id);
                  setOption(new_option);
                  onChange(new_option);
                  setReloading(true);
                }}
              />
            </div>
          </Grid>
        );
      })}
    </Grid>
  );
}
